import { combineReducers } from 'redux';
import CartComboServiceReducer from './reducers/CartComboServiceReducer';
import CartProductReducer from './reducers/CartProductReducer';
import UserReducer from './reducers/UserReducer';
import ScheduleReducer from './reducers/ScheduleReducer';
import OrderReducer from './reducers/OrderReducer';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    user: UserReducer,
    cartProduct: CartProductReducer,
    cartComboService: CartComboServiceReducer,
    schedule: ScheduleReducer,
    order: OrderReducer,
});

export default reducer;
